import axios from "@/plugins/axios";

let url = "/api/v1/me/codes/descendants/members";

/** @typedef {Record<'_id'|'username'|'name',string>} $Member */

export const members = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, members: $Member[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },

};

export default members;
